'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _PublicationDate = require('./components/PublicationDate.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_PublicationDate).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/shared-publication-date/lib/index.js
// module id = 369
// module chunks = 1